<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="false"
    title="提现"
    class="withdraw withdraw-dialog"
    @close="close">
    <div>
      <div class="form-tips">当月会员收益将于次月2日1时到账，提现款将于下月底到账，提现时间为5-20日，每月仅支持提现一次。</div>
      <div class="wrap">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="120px"
          label-position="left">
          <el-form-item label="可提取收益：">
            <div class="form-control-static">
              <strong>{{ financeXd + financeCash }}元</strong>
              <!-- <div style="font-size:12px;line-height: 1">(模板收益：{{ financeXd }}元，现金收益：{{ financeCash }}元)</div> -->
            </div>
          </el-form-item>
          <el-form-item label="本月限额：">
            <p class="form-control-static">{{ limitCash }}元</p>
          </el-form-item>
          <el-form-item
            label="提现类型："
            prop="type">
            <div class="radio">
              <el-radio
                v-model.number="form.type"
                :label="0"
                size="medium">本账号企业提现</el-radio>
              <div
                v-if="form.type === 0"
                class="result-block"
                style="margin-top: 1px;">
                <a
                  v-if="userBank.isbank == 1"
                  class="link"
                  target="_self"
                  @click="changeBankInfo">更换银行卡</a>
                <a
                  v-else-if="userBank.isbank == 0"
                  class="link"
                  :href="getLink('/usercenter/certification/enterpriseWithdrawal')"
                  target="_self">绑定银行卡</a>
                <a
                  v-else-if="userBank.isbank == 2"
                  class="link"
                  target="_self">审核中</a>
                <a
                  v-else-if="userBank.isbank == 3"
                  class="link"
                  target="_self"
                  @click="changeBankInfo">审核失败</a>
              </div>
            </div>
            <!--<div class="radio">-->
            <!--<el-radio v-model="form.type" label="1" size="medium">委托其他企业提现</el-radio>-->
            <!--</div>-->
          </el-form-item>
          <el-form-item
            label="提现金额："
            prop="money">
            <i
              class="icon-money"
              style="position: absolute;position: absolute;z-index: 100;font-size: 15px;left: 2px;line-height: 34px;">￥</i>
            <el-input
              v-model="form.money"
              placeholder=""
              type="number"
              class="input-with-select"
              style="width:300px;"
              @change="moneyChange"
              @input="moneyChange">
              <el-button
                slot="append"
                type="primary"
                @click="getMaxAccount">最大限额</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="税后所得：">
            <p class="form-control-static">
            <strong style="color:#ff5448;">{{ realAmount }}</strong>元</p>
          </el-form-item>
          <el-form-item label="收款账号：">
            <p class="form-control-static">
              <span v-if="userBank.isbank">
                <span>{{ userBank.bankName }}</span>
                <span style="margin-left: 3px;">{{ userBank.bankAccount }}</span>
              </span>
              <span v-else>暂无</span>
            </p>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button
        type="primary"
        @click="submitForm('form')">提 现</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCashXd, jugeBankInfo, getCash } from 'api/showker'
import certlocal from 'src/utils/certlocal'
import { saveUserBank } from 'src/api/withdraw'
export default {
  name: 'WithdrawDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var checkType = (rule, value, callback) => {
      if (value === 0) {
        if (!this.userBank.isbank) {
          return callback(new Error('请先绑定银行卡'))
        } else if (this.userBank.isbank === 3) {
          return callback(new Error('审核失败，请重新绑卡'))
        } else if (this.userBank.isbank === 2) {
          return callback(new Error('审核中，暂无法提现'))
        }
      }
      callback()
    }

    var checkMoney = (rule, value, callback) => {
      if (value < 0) this.form.money = 0
      if (!value) {
        return callback(new Error('请输入提现金额'))
      }
      if (value < 100) {
        return callback(new Error('提现金额小于100元，不支持提现'))
      }
      callback()
    }
    return {
      visible: this.show,
      financeXd: 0,
      financeCash: 0,
      withdrawCash: 0,
      limitCash: 0,
      realAmount: 0,
      userBank: {
        bankAccount: '',
        bankName: '',
        type: '',
        isbank: 0
      },
      form: {
        money: '',
        type: 0
      },
      time: null,

      rules: {
        type: [{ required: true, validator: checkType, trigger: 'blur' }],
        money: [{ required: true, validator: checkMoney, trigger: 'change' }]
      },
      requestLock: false
    }
  },
  watch: {
    show(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.visible = newValue
        if (newValue === true) {
          this.loadData()
        }
      }
    },
    'form.money': function(newv, oldv) {
      if (newv === oldv || newv > this.limitCash) return
      if (this.time) {
        clearTimeout(this.time)
        this.time = null
      }
      this.time = setTimeout(() => {
        this.getRealMoney()
      }, 500)
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return false
        if (this.requestLock) return
        this.requestLock = true
        getCash({
          cash: this.form.money
        }).then(res => {
          res = res.data
          if (res.code === 200) {
            this.$alert({
              title: '提示',
              message: '企业提现申请成功<br><p class="text-small">请于每月<span>25日</span>前依照规定开具发票并上传（发票金额须与提现金额一致），以便及时为您结算收益。<p><br><a target="_blank" href="http://bbs.eqxiu.com/thread-87978-1-1.html">查看发票开具规则及说明</a></p></p>',
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              type: 'success'
            })
            setTimeout(() => {
              this.visible = false
              this.requestLock = false
              this.uploadInvoice(res.obj, this.form.money)
            }, 300)
          } else {
            this.$alert({
              title: '提示',
              message: res.msg,
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              type: 'warning'
            })
            this.requestLock = false
          }
        })
      })
    },
    uploadInvoice(id, money) {
      this.dialog
        .openInvoice({
          id,
          money
        })
        .then(res => {})
        .catch(res => {
          console.log(res, 'res')
        })
    },
    resetData() {
      this.financeXd = 0
      this.financeCash = 0
      this.withdrawCash = 0
      this.limitCash = 0
      this.realAmount = 0
      this.userBank.bankAccount = ''
      this.userBank.bankName = ''
      this.userBank.type = ''
      this.userBank.isbank = 0
      this.form.money = ''
      this.form.type = 0
      this.$refs.form.resetFields()
    },
    changeBankInfo() {
      this.$confirm({
        title: '提示',
        message: '确定更换银行卡？<br><p class="text-small">企业账号更换银行卡须重新审核银行开户许可证，审核周期为3-5个工作日，审核结果会以站内信形式发送，审核通过后可进行提现。</p>',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        howClose: false,
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      }).then(() => {
        certlocal.removeCertLocal()
        window.location.href = Vue.env.host.base + '/usercenter/certification/enterpriseWithdrawal'
      }).catch(() => {

      })
    },
    certain() {
      this.visible = false
      this.resetData()
    },
    cancel() {
      this.visible = false
      this.resetData()
    },
    close() {
      this.$emit('hide')
      this.resetData()
    },
    getLink(url) {
      return Vue.env.host.base + url
    },
    moneyChange(value) {
      this.$nextTick(() => {
        // if (value !== '' && value.substr(0, 1) === '.') {
        //   this.form.money = ''
        // }
        // this.form.money = value.replace(/^0*(0\.|[1-9])/, '$1') // 粘贴不生效
        // this.form.money = this.form.money.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
        // this.form.money = this.form.money.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        // this.form.money = this.form.money.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        // // eslint-disable-next-line
        // this.form.money = this.form.money.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3') // 只能输入两个小数
        // if (this.form.money.indexOf('.') < 0 && this.form.money !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 if
        //   if (this.form.money.substr(0, 1) === '0' && this.form.money.length === 2) {
        //     this.form.money = this.form.money.substr(1, this.form.money.length)
        //   }
        // }
        var reg = /^\d+(\.\d+)?$/;
        if (reg.test(value)) {
          this.form.money = parseInt(value)
        }
        if (value > this.withdrawCash) {
          this.form.money = this.withdrawCash
        }
      })
    },
    loadData() {
      // 获取会员收益和秀点收益
      getCashXd().then(res => {
        res = res.data
        if (res.code === 200) {
          this.financeXd = res.map.financeXd
          this.financeCash = res.map.financeCash
          this.limitCash = res.map.limitCash ? res.map.limitCash : 0
          let sum = this.financeXd + this.financeCash
          this.withdrawCash = (sum < this.limitCash) ? Math.floor(sum) : Math.floor(this.limitCash)
        }
      })

      jugeBankInfo().then(res => {
        res = res.data
        if (res.code === 200) {
          this.userBank.bankAccount = res.map.bankAccount
          // TODO 这里假数据
          this.userBank.isbank = parseInt(res.map.isbank)
          this.userBank.bankName = res.map.bankName || ''
          this.userBank.type = res.map.type || 0
        }
      })
    },
    getRealMoney() {
      if (this.form.money < 100) {
        this.realAmount = this.form.money
        return
      }
      this.realAmount = this.form.money
    },
    getMaxAccount() {
      this.form.money = this.withdrawCash
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-tips {
    background: #eff8ff;
    border-radius: 2px;
    padding: 9px 2px;
    color: #999;
    font-size: 12px;
  }

  .wrap {
    padding: 24px;
  }

  .result-block {
    min-height: 20px;
    padding-left: 10px;
    float: right;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 220px;
    display: inline-block;
  }

  .dialog {
    width: 600px;
  }
</style>
